module.exports = __webpack_public_path__ + "static/media/CIF.44edf3e3.png";